// Console override utility for production logging
const originalConsole = { ...console };

console.debug = (...args) => {
  if (import.meta.env.DEV) {
    originalConsole.debug(...args);
  }
};

console.info = (...args) => {
  originalConsole.info(...args);
};

console.warn = (...args) => {
  originalConsole.warn(...args);
};

console.error = (...args) => {
  originalConsole.error(...args);
};

export default console;
